import { render, staticRenderFns } from "./ArchiveHelpTab.vue?vue&type=template&id=5e6ad19c&"
import script from "./ArchiveHelpTab.vue?vue&type=script&lang=js&"
export * from "./ArchiveHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports